import * as React from 'react';
import { CSSProperties } from '@material-ui/styles';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import styles from './ProductDetailsView.module.css';
import { selectPMPEnabled } from 'ducks/server/settings';
import { getDetailImageUrl } from 'lib/util/imageUrl';
// import { useBounds } from 'hooks/useBounds';
import { getYouTubePreviewUrl } from 'lib/util/getYouTubePreviewUrl';

type Props = {
  urls: { url: string; type: 'VIDEO' | 'IMAGE' }[];
  open: boolean;
  onClose: () => void;
};

export const AllPicturesView = ({ open, onClose, urls }: Props) => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = React.useState(0);
  const thumbnailStripOffset = 0;

  const pmpEnabled = useSelector(selectPMPEnabled);

  const handleNext = () => setActiveIndex((activeIndex + 1) % urls.length);
  const handlePrev = () => setActiveIndex(activeIndex === 0 ? urls.length - 1 : activeIndex - 1);

  const thumbnailStyle: CSSProperties = {
    transform: `translateX(-${thumbnailStripOffset}px)`,
  };

  React.useEffect(() => {
    if (!open) {
      const iframes = document.querySelectorAll('iframe');

      iframes?.forEach((iframe) => {
        iframe?.contentWindow?.postMessage(
          JSON.stringify({ event: 'command', func: 'stopVideo' }),
          '*'
        );
      });
    }
  }, [open]);

  return (
    <div className={clsx(styles['pictures__all'], open && styles['is-active'])}>
      <a className={styles['pictures__all__close']} onClick={onClose}>
        <p></p>
        {t('Close')}
      </a>
      <div className={styles['pictures__all__photo']}>
        <ul className={styles['pictures__all__photo__main']}>
          {urls.map((url, idx) => (
            <li key={url.url} className={clsx(idx === activeIndex && styles['is-active'])}>
              {url.type === 'IMAGE' ? (
                <img src={pmpEnabled ? getDetailImageUrl(url.url) : url.url} alt="TODO" />
              ) : (
                <iframe
                  width="100%"
                  height="100%"
                  src={`${url.url}?enablejsapi=1`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen={true}
                />
              )}
            </li>
          ))}
        </ul>
        <a
          className={clsx(styles['pictures__all__photo__btn'], styles['prev'])}
          onClick={handlePrev}
        ></a>
        <a
          className={clsx(styles['pictures__all__photo__btn'], styles['next'])}
          onClick={handleNext}
        ></a>
      </div>
      <div className={styles['pictures__all__thumbs']}>
        <ul className={styles['pictures__all__thumbs__main']} style={{ overflowX: 'auto' }}>
          {urls.map((url, idx) => (
            <li
              key={idx}
              className={clsx(activeIndex === idx && styles['is-active'])}
              style={thumbnailStyle}
              onClick={() => setActiveIndex(idx)}
            >
              {url.type === 'IMAGE' ? (
                <img src={pmpEnabled ? getDetailImageUrl(url.url) : url.url} alt="TODO" />
              ) : (
                <img src={getYouTubePreviewUrl(url.url)} alt="TODO" />
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
